export const CONNECT_SKVLLPVNKZ_AMMOLITE_UPDATER =
	'CONNECT_SKVLLPVNKZ_AMMOLITE_UPDATERS';
export const CONNECT_BABIEZ_AMMOLITE_UPDATER =
	'CONNECT_BABIEZ_AMMOLITE_UPDATERS';
export const SET_HIDEOUT_INTERVAL_ID = 'SET_HIDEOUT_INTERVAL_ID';
export const SET_DAYCARE_INTERVAL_ID = 'SET_DAYCARE_INTERVAL_ID';
export const INCREMENT_HIDEOUT_REWARDS = 'INCREMENT_HIDEOUT_REWARDS';
export const INCREMENT_DAYCARE_REWARDS = 'INCREMENT_DAYCARE_REWARDS';
export const RESET_PENDING_REWARDS_STATE = 'RESET_PENDING_REWARDS_STATE';
